/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function MenuOptionRegular({ icon, label, to, horizontal, collapsed }) {
  const location = useLocation();
  // Active if path matches. Handles basics like /dashboard/settings vs /dashboard
  // Strict check might be needed if dashboard is parent of others, but usually startsWith is better for sub-routes
  // For now exact match on to prop or startsWith if to is not root
  const isActive = to === '/dashboard'
    ? location.pathname === '/dashboard'
    : location.pathname.startsWith(to);

  return (
    <Link to={to} style={{ textDecoration: 'none' }}>
      <div
        className={`menu-option d-flex ${horizontal ? 'flex-row align-items-center' : 'flex-column align-items-center'} px-3 py-3`}
        style={{
          cursor: 'pointer',
          color: isActive ? '#fff' : 'rgba(255,255,255,0.7)',
          borderRadius: 12,
          marginBottom: 4,
          background: isActive
            ? 'linear-gradient(90deg, rgba(255,255,255,0.2) 0%, rgba(255,255,255,0.1) 100%)'
            : 'transparent',
          borderLeft: isActive ? '4px solid #fff' : '4px solid transparent',
          boxShadow: isActive ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
          backdropFilter: isActive ? 'blur(4px)' : 'none',
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
          justifyContent: collapsed ? 'center' : 'flex-start',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseEnter={(e) => {
          if (!isActive) {
            e.currentTarget.style.color = '#fff';
            e.currentTarget.style.background = 'rgba(255,255,255,0.05)';
          }
        }}
        onMouseLeave={(e) => {
          if (!isActive) {
            e.currentTarget.style.color = 'rgba(255,255,255,0.7)';
            e.currentTarget.style.background = 'transparent';
          }
        }}
      >
        <i className={`bi ${icon}`} style={{ fontSize: 20, filter: isActive ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))' : 'none' }}></i>
        {!collapsed && (
          <span style={{
            fontWeight: isActive ? 600 : 400,
            fontSize: 15,
            marginLeft: 14,
            letterSpacing: '0.3px'
          }}>
            {label}
          </span>
        )}
      </div>
    </Link>
  );
}

export default MenuOptionRegular;
